import { useState } from 'react';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Input } from 'reactstrap';
import { observer } from "mobx-react";
import { FeatureType } from "helpers/enum";

const FormDropdown = observer(({
  formItems = [],
  onFormSelected,
  isDisabled = false
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredForms = searchTerm
    ? formItems.filter(formItem =>
        formItem.name.toLowerCase().includes(searchTerm.toLowerCase()))
    : formItems;

  return (
    <UncontrolledDropdown sm={2} md={2} className="d-inline w-100">
      <DropdownToggle color="secondary" className="mr-0 merge-tags-dropdown w-100" id="form" caret disabled={isDisabled}>
        Form
      </DropdownToggle>
      <DropdownMenu dark className="survey-tags-dropdownmenu">
        <div className="merge-tags-search-input-container">
          <i className="fa fa-search" aria-hidden="true"></i>
          <Input
            type="search"
            placeholder="Type to search forms"
            className="merge-tags-search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        {filteredForms.length > 0 && filteredForms.map((item, index) => (
          <DropdownItem
            className="py-2 merge-tags-childe-dropdownitem"
            id={item.id}
            key={index}
            onClick={() => {
              const FORMS_URL = process.env.REACT_APP_FORMS_SERVICE_URL;
              onFormSelected({ 
                  link: `${FORMS_URL}/${item.formId}?type=${FeatureType.Form}`, 
                  name: item.name 
                });
            }}>
            {item.name}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
});

export default FormDropdown;